
define('text!views/pages/player/playerArea.html',[],function () { return '<div data-bind="router: { cacheViews: true }"></div>';});

